export const skipLinkControlButtonAriaLabel = "Bh4R5d";
export default {skipLinkControlButtonAriaLabel};